import { RowMenu } from '@components/RowMenu';
import { RowMenuItem } from '@components/RowMenuItem';
import { ILoading } from '@hooks/useLoading';
import { IMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import { Divider } from '@material-ui/core';
import HistoryIcon from '@material-ui/icons/History';
import { EnumDespesaStatus, EnumDespesaTipo, IDespesa } from '@model/Despesa';
import { AxiosResponse } from 'axios';
import React from 'react';
import { DespesaCancelarModal } from './DespesaCancelarModal';

export type DespesaMenuProps = {
    menu: IMenu
    despesa: IDespesa
    commandLoading: ILoading
    onDespesaAtualizada: (despesa: AxiosResponse<IDespesa>) => void
}

export function DespesaMenu ({ menu, commandLoading, despesa, onDespesaAtualizada }: DespesaMenuProps) {
    const atividadeModal = useModalWindow();
    const cancelarModal = useModalWindow();

    const handleSegundaViaRecibo = React.useCallback(() => {
        window.open(`DespesaRecibo/${despesa.despesaId}`);
    }, [despesa.despesaId]);
    

    return (
        <React.Fragment>
            <RowMenu
                menu={menu}
            >
                {
                    despesa.status !== EnumDespesaStatus.Cancelada && (
                        <React.Fragment>
                            <RowMenuItem 
                                key={1} 
                                onClick={menu.handleItemClick(cancelarModal.open)}
                                text="Cancelar"
                            />
                            <Divider />
                        </React.Fragment>
                    )
                }

                {
                    despesa.tipo === EnumDespesaTipo.Recibo && (
                        <React.Fragment>
                            <RowMenuItem 
                                key={1} 
                                onClick={handleSegundaViaRecibo}
                                text="Segunda via de recibo"
                            />
                            <Divider />
                        </React.Fragment>
                    )
                }
                <RowMenuItem 

                    key={2} 
                    onClick={menu.handleItemClick(atividadeModal.open)}
                    text="Atividades"
                    icon={<HistoryIcon />}
                />
            </RowMenu>

            <DespesaCancelarModal
                modal={cancelarModal}
                despesa={despesa}
                onDespesaCancelada={onDespesaAtualizada}
            />
        </React.Fragment>
    )
}